import { useApp } from 'context/app-context'
import { useCurrentUser } from 'context/current-user-context'
import useChannel from 'hooks/use-channel'
import { CHANNELS } from 'lib/pusher'
import { useEffect } from 'react'

const useSubscriptionListener = () => {
  const { isCustomer, uuid, refreshUser } = useCurrentUser()
  const channel = useChannel(CHANNELS.billing.subscriptionCreated)
  const { setFlashNotice } = useApp()

  useEffect(() => {
    channel?.bind(uuid, async (response) => {
      if (response.success) {
        setFlashNotice({
          type: 'success',
          message: 'Thank you for subscribing! Your team has been upgraded!',
        })
        refreshUser()
        channel.unbind()
      }
    })

    if (isCustomer && channel) {
      channel.unbind()
    }

    return () => {
      if (channel) {
        channel.unbind()
      }
    }
  }, [channel, isCustomer])
}

export default useSubscriptionListener
